export var AssetClassTag;
(function (AssetClassTag) {
    AssetClassTag["TREE"] = "Tree";
})(AssetClassTag || (AssetClassTag = {}));
//# sourceMappingURL=asset-class.interface.js.map